import { EmptySearchIcon } from '@modules/common/components/EmptySearchIcon';
import {
  Box,
  Stack,
  StackProps,
  Typography,
  TypographyProps,
} from '@mui/material';

interface RecordsNotFoundMessageProps {
  iconSize?: number;
  titleVariant?: TypographyProps['variant'];
  containerStackProps?: StackProps;
  titleMessage?: string;
}

export const RecordsNotFoundMessage = ({
  iconSize = 80,
  titleVariant = 'h5',
  containerStackProps,
  titleMessage = 'No Records Found',
}: RecordsNotFoundMessageProps) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="100%"
      width="100%"
      {...containerStackProps}
    >
      <EmptySearchIcon width={iconSize} height={iconSize} />
      <Stack direction="column" alignItems="center" spacing={2}>
        <Typography variant={titleVariant} pb={1}>
          {titleMessage}
        </Typography>
        <Stack spacing={0.5}>
          <Typography color="text.secondary" variant="body1">
            You can try:
          </Typography>
          <Typography color="text.secondary" variant="body1">
            <Box color="text.primary" component="span">
              ↔️
            </Box>{' '}
            Broadening your query's filters
          </Typography>
          <Typography color="text.secondary" variant="body1">
            <Box color="text.primary" component="span">
              🗓️
            </Box>{' '}
            Increasing the time duration
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
